var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2234 15.8123C39.9263 15.5913 39.5063 15.653 39.2853 15.9501C39.1637 16.1135 39.0336 16.2737 38.8986 16.4264C38.6534 16.7039 38.6794 17.1276 38.9568 17.3729C39.0844 17.4856 39.2428 17.541 39.4007 17.541C39.5861 17.541 39.7708 17.4645 39.9033 17.3146C40.0631 17.1338 40.2172 16.944 40.3611 16.7504C40.5822 16.4534 40.5205 16.0333 40.2234 15.8123Z",
    fill: "#EC6C2D",
    stroke: "#EC6C2D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4891 11.5236C42.1275 11.4448 41.7701 11.6743 41.6913 12.0361C41.648 12.2351 41.5956 12.4346 41.5356 12.6289C41.4262 12.9827 41.6244 13.3581 41.9782 13.4674C42.0442 13.4878 42.1108 13.4974 42.1764 13.4974C42.4627 13.4974 42.7278 13.3126 42.8168 13.0247C42.888 12.7941 42.9502 12.5575 43.0016 12.3213C43.0804 11.9595 42.8509 11.6024 42.4891 11.5236Z",
    fill: "#EC6C2D",
    stroke: "#EC6C2D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9118 7.41286V11.3547L32.4531 12.8133C32.1913 13.0752 32.1913 13.4997 32.4531 13.7615C32.5841 13.8925 32.7556 13.9579 32.9273 13.9579C33.0989 13.9579 33.2705 13.8924 33.4014 13.7615L35.0564 12.1065C35.1821 11.9808 35.2528 11.8103 35.2528 11.6324V7.41286C35.2528 7.04255 34.9526 6.74237 34.5823 6.74237C34.212 6.74237 33.9118 7.04255 33.9118 7.41286Z",
    fill: "#EC6C2D",
    stroke: "#EC6C2D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8235 5.87978C40.2628 3.43224 37.5374 1.90594 34.5822 1.90594C32.2898 1.90594 30.1347 2.79866 28.5137 4.4196C26.8927 6.0406 26 8.19577 26 10.4882C26 12.7806 26.8927 14.9357 28.5137 16.5567C30.1347 18.1777 32.2898 19.0704 34.5822 19.0704C34.5879 19.0704 34.5933 19.0697 34.599 19.0695C34.6046 19.0697 34.6101 19.0704 34.6157 19.0704C34.8574 19.0704 35.1014 19.0602 35.3411 19.0401C35.7101 19.0092 35.9842 18.6851 35.9533 18.3161C35.9224 17.9471 35.5986 17.6728 35.2292 17.7039C35.0266 17.7208 34.8202 17.7294 34.6157 17.7294C34.6101 17.7294 34.6046 17.7301 34.599 17.7302C34.5933 17.7301 34.5879 17.7294 34.5822 17.7294C30.5894 17.7294 27.341 14.481 27.341 10.4882C27.341 6.49532 30.5894 3.24692 34.5822 3.24692C37.1555 3.24692 39.5223 4.6185 40.8156 6.80049L40.8108 6.79249L41.8235 5.87978Z",
    fill: "#EC6C2D",
    stroke: "#EC6C2D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8815 7.34449L42.0098 7.86528C42.433 7.91866 42.8282 7.61202 42.8816 7.18886L43.4024 3.0605C43.4557 2.63735 43.1491 2.24217 42.7259 2.18879C42.3028 2.13541 41.9076 2.44205 41.8542 2.86521L41.4311 6.2195L38.0768 5.79636C37.6536 5.74298 37.2585 6.04962 37.2051 6.47278C37.1517 6.89593 37.4583 7.29111 37.8815 7.34449Z",
    fill: "#EC6C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6485 22.3889C31.7003 22.3889 30.4443 22.3679 28.8807 22.3679C25.0673 22.3679 21.9316 19.2116 21.9316 15.3623V8.60868C21.9316 8.07738 21.5076 7.64478 20.9813 7.64478H9.87362C4.68986 7.64478 0.5 11.8994 0.5 17.1137V39.7412C0.5 45.2117 4.88946 49.6448 10.3061 49.6448H26.8472C32.0122 49.6448 36.2 45.4175 36.2 40.199V23.3339C36.2 22.8005 35.7779 22.37 35.2498 22.3721C34.3619 22.3784 33.2972 22.3889 32.6485 22.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9956 28.432H23.4281C24.2912 28.432 24.9926 29.1313 24.9926 29.9944C24.9926 30.8575 24.2912 31.5589 23.4281 31.5589H11.9956C11.1325 31.5589 10.4332 30.8575 10.4332 29.9944C10.4332 29.1313 11.1325 28.432 11.9956 28.432Z",
    fill: "#F5C4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3039 36.8198H11.9953C11.1322 36.8198 10.4329 37.5191 10.4329 38.3822C10.4329 39.2453 11.1322 39.9467 11.9953 39.9467H23.3039C24.167 39.9467 24.8684 39.2453 24.8684 38.3822C24.8684 37.5191 24.167 36.8198 23.3039 36.8198Z",
    fill: "#F5C4AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 49,
    fill: "white",
    transform: "translate(0 0.863647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.495aa5180593c4ce86161befe91811ae.svg";
export { ForwardRef as ReactComponent };